import { ReactComponent as SURVEY_SVG } from 'assets/images/icon_survey.svg';
import { ReactComponent as SURVEY_HERO_SVG } from 'assets/images/survey_hero.svg';
import { ReactComponent as SURVEY_HERO_COMP_SVG } from 'assets/images/icon_survey_complete.svg';
import { ReactComponent as CHECKED_SVG } from 'assets/images/icon_checked.svg';
import { ReactComponent as UNCHECKED_SVG } from 'assets/images/icon_unchecked.svg';
import { ReactComponent as SLIDER_THUMB_SVG } from 'assets/images/icon_slider_thumb.svg';


export const svgs = {
    SURVEY_SVG,
    SURVEY_HERO_SVG,
    CHECKED_SVG,
    UNCHECKED_SVG,
    SLIDER_THUMB_SVG,
    SURVEY_HERO_COMP_SVG
}